import {Component, ElementRef, OnInit, ViewChild} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {DomSanitizer} from '@angular/platform-browser'

// Contents
import contentHeaderCommon from './contents/header/common/main'

@Component({
    selector: 'app-user-guide',
    templateUrl: 'user.guide.component.html',
    styleUrls: [
        'user.guide.component.css'
    ],
    standalone: false
})
export class UserGuideComponent implements OnInit {
  // Paragraphs
  // @ViewChild('manageTicketNames') manageTicketNames: ElementRef

  open: boolean
  content: string
  loaded: boolean

  openUserGuide() {
    console.log('open user guide')
    this.open = true
  }

  closeUserGuide() {
    this.open = false
  }

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    // this.content = require('./contents/header/common/main.html')
  }

  loadTerm() {
    this.content = contentHeaderCommon
    this.loaded = true
    // this.http.get('./contents/header/common/main.html', {
    //   responseType: 'text'
    // }).subscribe(res => {
    //   this.content = this.sanitizer.bypassSecurityTrustHtml(res)
    //   this.loaded = true
    // })
  }

  // init all contents ref
  initContentsRef() {
    // console.log('try to init elements: ', this.manageTicketNames)
    // this.manageTicketNames.nativeElement.addEventListener('scroll', i => {
    //   console.log('i: ', i)
    // }, false)
  }

  ngOnInit() {
    // setTimeout(this.initContentsRef, 1000)
  }
}
